import { render } from "./settlement-day.vue?vue&type=template&id=326fa488"
import script from "./settlement-day.vue?vue&type=script&lang=js"
export * from "./settlement-day.vue?vue&type=script&lang=js"

import exportComponent from "/home/Work/max/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__